module.exports = __webpack_public_path__ + "img/_givens_.b36402d4.svg";